import { Color } from '@billy/design-system'

import { BillStatus } from '@features/bills/enums/billStatus'

export const billStatusToOutlineColor: Partial<Record<BillStatus, Color>> = {
  [BillStatus.Paid]: Color.Green400,
  [BillStatus.PartiallyPaid]: Color.Green400,
  [BillStatus.Overdue]: Color.Red700,
}
